export const SELECT_TEMPLATE = "SELECT_TEMPLATE";
export const CLEAR_SELECTED_TEMPLATE = "CLEAR_SELECTED_TEMPLATE";
export const TEMPLATE_ADD_KEY = "TEMPLATE_ADD_KEY";
export const TEMPLATE_ADD_KEYS = "TEMPLATE_ADD_KEYS";
export const TEMPLATE_REMOVE_KEY = "TEMPLATE_REMOVE_KEY";
export const TEMPLATE_SET_KEYS = "TEMPLATE_SET_KEYS";
export const TEMPLATE_CHANGE_COUNTRY = "TEMPLATE_CHANGE_COUNTRY";
export const TEMPLATE_SET_PARENT = "TEMPLATE_SET_PARENT";
export const TEMPLATE_SET_ORIGIN = "TEMPLATE_SET_ORIGIN";
export const TEMPLATE_SET_INITIAL_TITLE = "TEMPLATE_SET_INITIAL_TITLE";
export const SELECT_SEGMENTS_GROUP = "SELECT_SEGMENTS_GROUP";
export const SET_SEGMENTS_IDS = "SET_SEGMENTS_IDS";
